"use client";
import Image from "next/image";
import { useState } from "react";

export const LeftSideImageBackground = () => {
  const [origin, setOrigin] = useState("center");
  const [hover, setHover] = useState(false);

  const move = (_clientX: number, clientY: number, el: HTMLDivElement) => {
    const r = el.getBoundingClientRect();
    const y = ((clientY - r.top) / r.height) * 100;
    // X fija en el borde izquierdo (junto a la tarjeta) para que ese borde no tiemble
    setOrigin(`0% ${y}%`);
  };

  return (
    <div
      className="relative bg-black  w-full hidden overflow-hidden isolate  lg:block"
      onMouseMove={(e) => move(e.clientX, e.clientY, e.currentTarget)}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onTouchStart={(e) => {
        setHover(true);
        move(e.touches[0].clientX, e.touches[0].clientY, e.currentTarget);
      }}
      onTouchMove={(e) => move(e.touches[0].clientX, e.touches[0].clientY, e.currentTarget)}
      onTouchEnd={() => setHover(false)}
    >
      <Image
        src="/bg-home.webp"
        alt="auth truck background"
        fill
        style={{ transformOrigin: origin, transform: `scale(${hover ? 1.05 : 1})` }}
        className="object-cover object-left-center w-full h-full transform-gpu will-change-transform [backface-visibility:hidden] transition-transform duration-500 ease-out"
        priority
      />

      <div className="p-8 text-white pointer-events-none relative">
        <Image
          className="w-auto h-18 invert"
          src="/logo.webp"
          alt="logo"
          width={150}
          height={150}
          priority
        />
      </div>
    </div>
  );
};
